import { UserGroupDataModel, UserGroupModel } from 'src/app/admin/models/group.model';
import { Question, QuestionAnswer } from 'src/app/shared/components/page/page.model';
import { WorkflowStepConfiguration } from './WorkflowStepConfig.model';

export class WorkflowSteps
{
    workflowId:number;
    workflowStepId:number;
    name:string;
    description:string;
    sequenceNumber:number;
    stepGuid:string;
    isDeleted:boolean=false;
    workflowStepSections:WorkflowStepSection[]=[];
    workflowStepConfig:WorkflowStepConfiguration[]=[];
    isExpanded:boolean=false;
    //isSectionExpanded:boolean=false;
    questionAnswer:Question[]=[];
    workflowStepUserGroupMap:WorkflowUserGroupMapping[]=[];
    userGroups:UserGroupDataModel;//UserGroupDataModel;
    ValidStepConfig:Array<WorkflowStepConfiguration[]>=[];


    sectionsList : QuestionAnswer[];  
    stepStatus :string;
    dueDate:string;
    dueDaysCount:number;
    isDueDateEnabled :boolean= false;
    dueDateQuestionId:number;
    duedateQuestions :Question[]=[];
}


export class WorkflowStepSection
{
    workflowStepSectionRelId:number;
    workflowStepId:number;
    workflowStepGuid:string;
    pageSectionId:number;
    sectionId: number;
    sequenceNumber:number;
    accessLevel:string;
    isDeleted:boolean=false;
}

export class WorkflowUserGroupMapping
{
    workflowStepUserGroupMappingId:number;
    userId:string;
    groupId:string;
    workflowStepId:number;
    isDeleted:boolean=false;
}

// export class WorkflowInstance
// {
//     workflowInstanceId:number;
//     workflowId:number;
//     isDeleted:boolean=false;
//     workflowStepInstace:WorkflowStepInstance[]=[];
// }

// export class WorkflowStepInstance
// {
//     workflowInstanceId:number;
//     workflowStepId:number;
//     workflowStepInstanceId:number;
//     userId:string[]=[];
//     groupId:string[]=[];
//     isDeleted:boolean=false;
// }
